import { render } from "./App.vue?vue&type=template&id=0c1c51bd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0c1c51bd&lang=css"

import exportComponent from "/home/runner/work/veins_checkin_vue/veins_checkin_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__